import http from "./http";

export function updateReadyForSim(interfaceId, status) {
  return http.put(`/project/design/interface/${interfaceId}/simStatus?status=${status}`);
}